var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"monacoEditor"},[_c('div',{staticStyle:{"height":"100%"},attrs:{"id":_vm.jsonEditorId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }